import * as React from 'react';

import styles from './PrintPhoto.css';
import { IPhotoSchema } from '../../types';
import { getMicrodata } from '../../utils/microdata';

export interface IPrintPhotoProps {
  photos: IPhotoSchema[] | null;
}

export const PrintPhoto = (props: IPrintPhotoProps) => {
  const { photos } = props;

  if (!photos) {
    return null;
  }

  const photosWithUrl = photos.filter(({ fullUrl }) => Boolean(fullUrl));

  if (photosWithUrl.length === 0) {
    return null;
  }

  return (
    <div className={styles['container']} {...getMicrodata('ImageObject')}>
      <img className={styles['photo']} src={photosWithUrl[0].galleryThumbnailUrl} itemProp="url" />
    </div>
  );
};
